import { render, staticRenderFns } from "./DashboardJobsChart.vue?vue&type=template&id=17963a09&scoped=true"
import script from "./DashboardJobsChart.vue?vue&type=script&lang=js"
export * from "./DashboardJobsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17963a09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17963a09')) {
      api.createRecord('17963a09', component.options)
    } else {
      api.reload('17963a09', component.options)
    }
    module.hot.accept("./DashboardJobsChart.vue?vue&type=template&id=17963a09&scoped=true", function () {
      api.rerender('17963a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardJobsChart.vue"
export default component.exports